import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

class MyVerticallyCenteredModal extends Component{
  render() {
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{fontFamily: "'Hachi Maru Pop', cursive", fontWeight: "bold"}}
      >
        <Modal.Body>
          <p className="text-danger">{this.props.title}</p>
          <p className="text-success">{this.props.message}</p>
        </Modal.Body>
        <Modal.Footer>
          {
            this.props.onSubmit &&
            <Button onClick={this.props.onSubmit} variant="outline-danger">
              <FormattedMessage id="button.ok.submit" defaultMessage="OK, let's do it." />
            </Button>
          }
          <Button onClick={this.props.onHide} variant="outline-success">
            <FormattedMessage id="button.close" defaultMessage="Close" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default MyVerticallyCenteredModal;